import React from 'react'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Toolbar from '@material-ui/core/Toolbar'
import { NavLink as ReactRouterLink } from 'react-router-dom'
import Hidden from '@material-ui/core/Hidden'

import { useLayoutSidebarStyles } from './layout-sidebar.styles'

export type LayoutSidebarProps = {
  isOpen?: boolean
  input?: React.ReactNode
  sidebarOptions?: Menu[]
}

export type Menu = {
  title: string
  icon: JSX.Element
  link: string
}

export const LayoutSidebar: React.FC<LayoutSidebarProps> = (props) => {
  const classes = useLayoutSidebarStyles()

  return (
    <Hidden mdDown implementation="css">
      <Drawer
        className={classes.drawer}
        variant="permanent"
        open={props.isOpen}
        classes={{
          paper: classes.drawerPaper
        }}
        ModalProps={{
          keepMounted: true
        }}
      >
        <Toolbar />
        {props.input}
        <List className={classes.list}>
          {props.sidebarOptions?.map(({ title, icon, link }) => (
            <ListItem
              component={ReactRouterLink}
              activeClassName={classes.activeLink}
              to={link}
              button
              key={title}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={title} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </Hidden>
  )
}
